// extracted by mini-css-extract-plugin
module.exports = {"close":"_slIoEFLw1TZ7KFzMklin"};